import { Icon } from '../../../../../../common/html/icon'
import { Image } from '../../../../../../common/image'
import pdfIcon from './pdfIcon.svg'
import xlsIcon from './xlsIcon.svg'

const xlsx = '.xlsx'
const pdf = '.pdf'

const mapIcon = {
  [xlsx]: xlsIcon,
  [pdf]: pdfIcon,
}

export const FileType = ({ fileType }) => {
  return fileType ? (
    mapIcon[fileType] ? (
      <Image
        src={mapIcon[fileType]}
        alt="file type"
        style={{ width: 20, height: '100%' }}
      />
    ) : (
      <Icon
        className="icon-description"
        style={{ fontSize: 20, color: '#ccc' }}
      />
    )
  ) : null
}
